import React from 'react'

function Broadban() {
    return (
        <>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Rohde & Schwarz</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">EMC Test Equipments
                        </a>
                        <i class="fa fa-angle-right"></i>
                        <span>Broadband Amplifiers </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div>
                    <h1 className='text-center ' style={{ textDecoration: "underline" }}>Broadband Amplifiers </h1>
                </div>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/broadband.jpg' width={400} ></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>R&S®TS8996:</h2>
                        <p class="mbot25">
                            R&S broadband amplifiers are innovative solid-state solutions
                            with exceptional RF performance for generating RF power up to
                            13 kW in the frequency range of 4 kHz to 6 GHz. Designed as
                            very compact amplifiers, at highest power density, they are
                            robust against severest output mismatch while featuring high
                            availability. Applications range from amplitude, frequency, phase,
                            pulse to OFDM modulation. Its modular structure allows for fieldproven
                            scalability of systems. Sophisticated switching options for input,
                            output and sample ports will match your needs when it comes to even
                            complex RF systems set-ups.
                        </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Broadban
